import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shang",
  "use": "icon-shang-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shang\"><defs><style type=\"text/css\"></style></defs><path d=\"M430.72 393.216v529.856c0 8.576 7.68 15.616 17.088 15.616h128c9.344 0 17.024-7.04 17.024-15.616V393.216h158.08c14.272 0 22.144-15.04 13.44-25.152L525.44 91.328a18.048 18.048 0 0 0-26.88 0l-238.912 276.48c-8.704 10.368-0.832 25.408 13.44 25.408H430.72z\" p-id=\"3411\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol